import { render } from "./MatchByMoat.vue?vue&type=template&id=ea28b6e2"
import script from "./MatchByMoat.vue?vue&type=script&lang=js"
export * from "./MatchByMoat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__